import React, { useState, useEffect } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    TextField,
    CircularProgress
} from '@material-ui/core';

import api from '../../services/api';
import toastError from '../../errors/toastError';
import { toast } from "react-toastify";
import { i18n } from '../../translate/i18n';

const LinkContactModal = ({ modalOpen, onClose, contactId, onLinkSuccess }) => {
    const [targetPhoneNumber, setTargetPhoneNumber] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setTargetPhoneNumber('');
    }, [modalOpen])

    const handleLink = async () => {
        setLoading(true);
        try {
            await api.post(`/contacts/${contactId}/link`, {
                targetPhoneNumber: targetPhoneNumber.replace(/\D/g, "")
            });
            toast.success("Contato vinculado com sucesso!");
            if (onLinkSuccess) onLinkSuccess();
            onClose();
        } catch (err) {
            toastError(err);
        }
        setLoading(false);
    };

    return (
        <Dialog open={modalOpen} onClose={onClose} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">Vincular Contato LID</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Este contato é um identificador oculto (LID). Para unificar o histórico e prevenir duplicidade,
                    informe o número de WhatsApp real (ex: 551199999999) deste contato.
                </DialogContentText>
                <TextField
                    autoFocus
                    margin="dense"
                    id="number"
                    label="Número do WhatApp (Ex: 551199999999)"
                    type="text"
                    fullWidth
                    value={targetPhoneNumber}
                    onChange={(e) => setTargetPhoneNumber(e.target.value)}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="secondary" disabled={loading}>
                    {i18n.t("common.cancel")}
                </Button>
                <Button onClick={handleLink} color="primary" disabled={loading || !targetPhoneNumber}>
                    {loading ? <CircularProgress size={24} /> : "Vincular"}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default LinkContactModal;
